class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    const message = this.textContent.trim();
    this.innerHTML = `
      <div class="announcement-bar__scroll-wrapper">
        <div class="announcement-bar__scroll-content">
          <span>${message}</span>
          <span aria-hidden="true">${message}</span>
        </div>
      </div>
    `;
    this.startScroll();
  }

  startScroll() {
    const content = this.querySelector('.announcement-bar__scroll-content');
    if (!content) return;
    const wrapper = this.querySelector('.announcement-bar__scroll-wrapper');
    const contentWidth = content.scrollWidth / 2;
    content.style.animationDuration = `${contentWidth / 50}s`;
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
